import DisputesScreen from 'features/myVaro/screens/Disputes/DisputesScreen';
import React from 'react';

export default function DisputesPage() {
  return <DisputesScreen />;
}
